import { Grid as ChakraGrid, HStack, Progress, Text } from '@chakra-ui/react';
import { Star } from '@time-line/components/icons';

interface ReviewRatingBarProps {
  rating: string;
  total: number;
  amount: number;
  isInactive?: boolean;
}

export function ReviewRatingBar({
  rating,
  total,
  amount,
  isInactive,
}: ReviewRatingBarProps) {
  const percentage = Math.round((amount / total) * 100);
  const textColor = isInactive ? 'blackAlpha.700' : 'gray.600';
  const lineColor = isInactive ? 'blackAlpha.250' : 'gray.600';

  return (
    <ChakraGrid gap="2xs" templateColumns="28px 1fr 35px" alignItems="center">
      <HStack gap="5xs">
        <Star boxSize="2xs" mt="-4px" color={textColor} />
        <Text
          as="span"
          size="detail"
          color={textColor}
          sx={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {rating}
        </Text>
      </HStack>
      <Progress
        aria-label={`${rating} star reviews: ${percentage}%`}
        value={percentage}
        h="6px"
        bg="blackAlpha.250"
        borderRadius="full"
        sx={{
          div: {
            bg: lineColor,
          },
        }}
      />
      <Text
        as="span"
        size="detail"
        justifySelf="end"
        color={textColor}
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      >{`${percentage}%`}</Text>
    </ChakraGrid>
  );
}
